export const CART_ADD_ITEM_REQUEST = "CART_ADD_ITEM_REQUEST";
export const CART_REMOVE_ITEM_REQUEST = "CART_REMOVE_ITEM_REQUEST";
export const CART_LIST_ITEM_REQUEST = "CART_LIST_ITEM_REQUEST";
export const CART_INCREMENT_ITEM_REQUEST = "CART_INCREMENT_ITEM_REQUEST";

export const CART_ADD_ITEM_SUCCESS = "CART_ADD_ITEM_SUCCESS";
export const CART_REMOVE_ITEM_SUCCESS = "CART_REMOVE_ITEM_SUCCESS";
export const CART_LIST_ITEM_SUCCESS = "CART_LIST_ITEM_SUCCESS";
export const CART_INCREMENT_ITEM_SUCCESS = "CART_INCREMENT_ITEM_SUCCESS";

export const CART_ADD_ITEM_FAILS = "CART_ADD_ITEM_FAILS";
export const CART_REMOVE_ITEM_FAILS = "CART_REMOVE_ITEM_FAILS";
export const CART_LIST_ITEM_FAILS = "CART_LIST_ITEM_FAILS";
export const CART_INCREMENT_ITEM_FAILS = "CART_INCREMENT_ITEM_FAILS";

export const CART_INCREMENT_ITEM_RESET = "CART_INCREMENT_ITEM_RESET";
export const CART_ADD_ITEM_RESET = "CART_ADD_ITEM_RESET";
export const CART_REMOVE_ITEM_RESET = "CART_REMOVE_ITEM_RESET";
export const CART_LIST_ITEM_RESET = "CART_LIST_ITEM_RESET";

export const CLEAR_CART_ERRORS = "CLEAR_CART_ERRORS";

export const CART_SAVE_SHIPPING_ADDRESS = "CART_SAVE_SHIPPING_ADDRESS";
export const CART_SAVE_PAYMENT_METHOD = "CART_SAVE_PAYMENT_METHOD";
